import React from 'react';
import { withTranslation } from 'react-i18next';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import makeStyles from '@mui/styles/makeStyles';
// components
import { PhotoPreview } from './index';

const useStyles = makeStyles({
    mainDiv:props=>({
        width:'100%',
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        marginTop:'10px',
        "& span":{
            color: props.fontDarkColor ? props.fontDarkColor : '#0F467A',
            fontWeight:'bold',
            cursor:'pointer',
            alignSelf:'flex-end'
        }
    }),

    photoDiv:{
        width:'100%',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        flexWrap:'wrap'
    },

    imageDiv:{
        width:'70px',
        height:'70px',
        cursor:'pointer',
        marginBottom:'10px',
        borderRadius:"5px",
        "& img":{
            width:'100%',
            height:'100%',
            borderRadius:"5px",
        }
    },

    marLeft:{
        marginLeft:'10px'
    },
    marRight:{
        marginRight:'10px'
    }
})
// Photo list template
function PhotoGallery(props) {
    const [showItems, setShowItems] = React.useState(6);
    const [photoIndex, setIndex] = React.useState(0);
    const [photoPreviewDialog,setDialog] = React.useState(false);

    const handleShowMore = () => { // pagination click event
        setShowItems(showItems >= photos.length ? showItems : showItems+6);
    }

    const openDialog = index => { // open photo preview dialog
        setDialog(true);
        setIndex(index ? index : 0);
    }
    const closeDialog = () => { // close photo preview dialog
        setDialog(false);
        setIndex(0);
    }

    const { t, i18n,fontDarkColor, photos } = props;
    const classes = useStyles({fontDarkColor})
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    return(
        <div className={classes.mainDiv}>
            <div className={classes.photoDiv}>
            {React.Children.toArray(photos.slice(0,showItems).map((v,i)=> {
                return (
                    <div className={`${classes.imageDiv} ${isRTL === 'ar' ? classes.marLeft : classes.marRight}`} onClick={()=> openDialog(i)}>
                        <ImgLazyLoad>
                            <img src={v.path} alt='photos' />
                        </ImgLazyLoad>
                    </div>
                    )
            }))}
            </div>
            {showItems >= photos.length ?
                undefined
            :
                <span style={{fontFamily}} onClick={handleShowMore}>{t('booking.see more')}</span>
            }
            {/* photo preview dialog */}
            {photoPreviewDialog && <PhotoPreview index={photoIndex} dataArray={photos} closeEvent={closeDialog} />}
        </div>
    )
}

export default withTranslation('common')(PhotoGallery);